import React from 'react';
// APOLLO
import { compose, graphql } from 'react-apollo';
import invoiceByIdQuery from 'ApolloClient/Queries/invoiceById';
// LIB
import RecomposeHelpers from 'lib/helpers/RecomposeHelpers';
import CurrencyHelpers from 'lib/helpers/CurrencyHelpers';
import styled from 'styled-components';
//
import TopSection from './TopSection';
import BottomBar from './BottomBar';
import InvoiceArea from './InvoiceArea';
import PaymentFormArea from './PaymentFormArea';

const Container = styled.div`
  width: 100%;
  height: 100%;
`;

const FormContainer = styled.div`
  flex: 1;
  width: 850px;
  max-width: 100%;
`;

const BottomSpacer = styled.div`
  flex: 2;
  min-height: 100px;
`;

const InvoiceContainer = styled.div`
  max-width: 100%;
  flex: 5;
  padding: 5px;
  min-height: 435px;
`;

class InvoicePay extends React.PureComponent {
  render() {
    const { invoiceById } = this.props.invoiceByIdQuery;

    if (!invoiceById) {
      return <div>Can't find this</div>;
    }

    let currencySymbol = CurrencyHelpers.getCurrencySymbol(invoiceById.currency);

    return (
      <Container>
        <TopSection invoice={invoiceById} />
        <div className="contract-step-container">
          <FormContainer>
            <PaymentFormArea invoice={invoiceById} currencySymbol={currencySymbol} />
          </FormContainer>
          <InvoiceContainer>
            <InvoiceArea invoice={invoiceById} currencySymbol={currencySymbol} />
          </InvoiceContainer>
          <BottomSpacer />
        </div>
        <BottomBar invoice={invoiceById} />
      </Container>
    );
  }
}

let options = ({ match }) => {
  let _id = match.params._id;
  return {
    variables: { _id },
  };
};

export default compose(
  graphql(invoiceByIdQuery, { options, name: 'invoiceByIdQuery' }),
  RecomposeHelpers.errorHOC({ propName: 'invoiceByIdQuery' }),
  RecomposeHelpers.loadingHOC({ propName: 'invoiceByIdQuery' }),
)(InvoicePay);



// WEBPACK FOOTER //
// ./src/routes/invoice-pay/index.js